module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarBasisgenus",
    staticClass: "sidebar-basisgenus"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "list-col col-6"
  }, [_c('erco-list', {
    staticClass: "list-available-genus",
    attrs: {
      "items": _vm.data.draggable,
      "draggable": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "destinations-col col-6"
  }, _vm._l((_vm.data.destinations), function(destination, index) {
    return _c('div', {
      key: index,
      staticClass: "input-wrapper",
      on: {
        "dragover": function($event) {
          _vm.handleDragOver($event)
        },
        "drop": function($event) {
          _vm.handleDrop(index, $event)
        }
      }
    }, [_c('erco-text-input', {
      attrs: {
        "keepUnfocused": true,
        "label": destination.label,
        "text": destination.text,
        "resetable": true,
        "droppable": true
      },
      on: {
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65aebbe1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/Basisgenus.vue
// module id = 626
// module chunks = 0